module.exports = __webpack_public_path__ + "img/pain-spot-13.9dd2c2fd.svg";